import React, { useState, useEffect, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { getPendingTrainingApprovals } from '../../services/trainingService';
import { parseTableParams } from '../../utils/Utils';
import { dateFilterColumn } from '../../utils/dateFilterColumn';
import DataTable from '../../components/ui/DataTable';

const Container = styled.div``;

export default function TrainingPendingApprovalsPage() {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const lang = i18n.language;

  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [pagination, setPagination] = useState({ totalRowCount: 0, pageSize: 10, pageIndex: 0 });
  const [queryParams, setQueryParams] = useState({ pageSize: 10, pageNumber: 1 });
  const [filterList, setFilterList] = useState([]);

  const fetchData = useCallback((params) => {
    setFetching(true);
    getPendingTrainingApprovals(params)
      .then((res) => {
        const result = res.data?.data;
        const items = Array.isArray(result) ? result : (result?.data || []);
        setData(items);
        setPagination({
          totalRowCount: result?.totalRowCount || items.length,
          pageIndex: result?.pageIndex ? result.pageIndex - 1 : 0,
          pageSize: result?.pageSize || items.length || 10,
        });
      })
      .catch(() => {})
      .finally(() => setFetching(false));
  }, []);

  useEffect(() => { fetchData(queryParams); }, [queryParams, fetchData]);

  const columns = useMemo(() => [
    { name: 'trainingId', label: 'ID', options: { filter: false, sort: false, display: 'excluded' } },
    { name: 'title', label: t('training.title'), options: { filter: true, sort: true, filterType: 'textField', filterOptions: { defaultOp: 'like' } } },
    dateFilterColumn('submittedAt', t('training.createDate'), lang),
  ], [t, lang]);

  const handleDataStateChange = useCallback((action, tableState) => {
    setFilterList(tableState.filterList);
    const params = parseTableParams(tableState, columns);
    setQueryParams(params);
  }, [columns]);

  const handleFilterConfirm = useCallback((newFilterList) => {
    setFilterList(newFilterList);
  }, []);

  const handleRowClick = useCallback((row) => {
    if (row?.trainingId) history.push(`/trainings/${row.trainingId}/review`);
  }, [history]);

  return (
    <Container>
      {useMemo(() => (
        <DataTable
          title={t('menu.trainingPendingApprovals')}
          fetching={fetching}
          columns={columns}
          data={data}
          totalRowCount={pagination.totalRowCount}
          pageIndex={pagination.pageIndex}
          pageSize={pagination.pageSize}
          filterList={filterList}
          onFilterConfirm={handleFilterConfirm}
          onTableChanged={handleDataStateChange}
          onRowClick={handleRowClick}
          customIdSelector="trainingId"
        />
      ), [t, fetching, columns, data, pagination, filterList, handleFilterConfirm, handleDataStateChange, handleRowClick])}
    </Container>
  );
}
